// extracted by mini-css-extract-plugin
export default {"wrapperCard":"style-module--wrapperCard--d0Qks","icon":"style-module--icon--4245y"};